import { MX_STAGES, Stage, UK_STAGES, US_STAGES } from "../helpers/get-settings";
import React from "react";
import { StatusEnum } from "../hoc/with-status";
import {
  AIR_BGC,
  BACKGROUNDCHECK_INFORMATION,
  BADGE_PHOTO,
  BGC,
  COMPLETE_NEW_HIRE_ORIENTATION,
  COMPLETE_PRE_EMPLOYMENT_SCREENING,
  CREATE_EMPLOYEE_A_TO_Z_ACCOUNT,
  DRUG_TEST,
  EMPLOYMENT_PAPERWORK,
  I_9_AUTHORIZATION_FORM,
  I_9_DOCUMENT,
  MEDICAL_CHECK,
  NEW_HIRE_VIDEO,
  ORDER_YOUR_SAFETY_SHOE,
  PROVIDE_PERSONAL_INFORMATION,
  SUBTASK,
  TASK,
  DOC_UPLOADS,
  UPLOAD_REQUIRED_DOCUMENTS,
  SCHEDULE_RIGHT_TO_WORK_APPOINTMENT,
} from "./taskConfigConstants";

export interface PopoverProps {
  title: string;
  body?: string[];
  buttonText?: string;
}

interface TaskWithStatus {
  (status: StatusEnum, isExpanded?: boolean, taskId?: string): React.ReactNode;
}

export interface Task {
  titleText: string;
  details?: React.ReactNode | TaskWithStatus;
  buttonText?: string;
  href?: string | Record<Stage, string>;
  isLink?: boolean;
  analyticsOnAction?: string;
  analyticsOnExpand?: string;
  /**
   * The path where task status information can be retrieved.
   */
  titleStatusPath?: string;
  subtasks?: Task[];
  errorStatusDetailMessage?: React.ReactNode;
  statusDetailMessage?: Record<StatusEnum | string, React.ReactNode>;
  hideWhenError?: boolean;
  isFallback?: boolean;
  expandWhenNotStarted?: boolean;
  popover?: PopoverProps;
  disableWhenCompleted?: boolean;
  shouldOverrideStatus?: Record<string, StatusEnum>;
  defaultStatus?: StatusEnum;
  hideInProd?: boolean;
  hideOnConfig?: boolean;
  taskStatusName?: string;
  hideOnTaskStatusError?: boolean;
  getTaskStatusByBBId?: boolean;
  checkBusinessLine?: boolean;
  taskName?: string;
  icon?: string;
  duration?: number;
}

export interface TaskGroup {
  name: string;
  tasks: Array<Task>;
  id?: string;
}

const US_TASKS_LIST = [
  I_9_DOCUMENT,
  I_9_AUTHORIZATION_FORM,
  NEW_HIRE_VIDEO,
  BADGE_PHOTO,
  COMPLETE_PRE_EMPLOYMENT_SCREENING,
  PROVIDE_PERSONAL_INFORMATION,
  ORDER_YOUR_SAFETY_SHOE,
  EMPLOYMENT_PAPERWORK,
  COMPLETE_NEW_HIRE_ORIENTATION,
  CREATE_EMPLOYEE_A_TO_Z_ACCOUNT,
  BACKGROUNDCHECK_INFORMATION,
  DOC_UPLOADS, // TODO: WIP - for devel local only
  SCHEDULE_RIGHT_TO_WORK_APPOINTMENT, // TODO: WIP - for dev local only, remove later
];

const MX_TASKS_LIST = [
  UPLOAD_REQUIRED_DOCUMENTS,
  //  "Watch the new hire video", //TODO: Uncomment if enhance with "MX new hire video"
  BADGE_PHOTO,
  COMPLETE_PRE_EMPLOYMENT_SCREENING,
  EMPLOYMENT_PAPERWORK,
  COMPLETE_NEW_HIRE_ORIENTATION,
  CREATE_EMPLOYEE_A_TO_Z_ACCOUNT,
];

const UK_TASKS_LIST = [
  I_9_DOCUMENT,
  I_9_AUTHORIZATION_FORM,
  NEW_HIRE_VIDEO,
  BADGE_PHOTO,
  COMPLETE_PRE_EMPLOYMENT_SCREENING,
  PROVIDE_PERSONAL_INFORMATION,
  ORDER_YOUR_SAFETY_SHOE,
  EMPLOYMENT_PAPERWORK,
  COMPLETE_NEW_HIRE_ORIENTATION,
  CREATE_EMPLOYEE_A_TO_Z_ACCOUNT,
  BACKGROUNDCHECK_INFORMATION,
  SCHEDULE_RIGHT_TO_WORK_APPOINTMENT,
];

const US_SUBTASKS_LIST = [BGC, AIR_BGC, DRUG_TEST];

const MX_SUBTASKS_LIST = [BGC, DRUG_TEST, MEDICAL_CHECK];

const UK_SUBTASKS_LIST = [BGC, DRUG_TEST, MEDICAL_CHECK];

export function isTaskEnabled(taskName: string, taskType: string, stage: string) {
  if (!stage) {
    return false;
  }

  const ALL_STAGES: Record<string, Stage[]> = {
    US: US_STAGES,
    MX: MX_STAGES,
    UK: UK_STAGES,
  };

  let activeStage = "";
  Object.keys(ALL_STAGES).forEach((countryCode) => {
    if (ALL_STAGES[countryCode].includes(stage as Stage)) {
      return (activeStage = countryCode);
    }
  });

  const stages: Record<string, string[]> = {
    US: US_TASKS_LIST,
    MX: MX_TASKS_LIST,
    UK: UK_TASKS_LIST,
  };

  const subtasks: Record<string, string[]> = {
    US: US_SUBTASKS_LIST,
    MX: MX_SUBTASKS_LIST,
    UK: UK_SUBTASKS_LIST,
  };

  let isEnabled = false;

  if (taskType === TASK) {
    isEnabled = stages[activeStage].includes(taskName);
  } else if (taskType === SUBTASK) {
    isEnabled = subtasks[activeStage].includes(taskName);
  }

  return isEnabled;
}
